<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<h1 style="font-family:Ariel">Acknowledgement</h1>
<p style="text-align: center;">My son Kerry Hale for his words of encouragement on the back cover. And my partner Beth for assistance with typing and submission for publication.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?b8cd6b36